import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src", "loading"]
const _hoisted_2 = ["src", "loading"]
const _hoisted_3 = ["src", "loading"]
const _hoisted_4 = {
  key: 5,
  class: "rounded-full p-1 bg-black text-yellow-400 w-6 h-6 absolute left-0.5 top-0.5 z-20"
}
const _hoisted_5 = {
  key: 0,
  class: "text-white -mt-2 mb-2"
}

import { ref } from 'vue';
import { StarFilled, PlayCircleFilled } from '@ant-design/icons-vue';
import ImageCard from '@/components/shared/ImageCard.vue';
import { File, Document, DocumentType } from '@/model/document';
import { DocumentViewMode, ActionMode } from '@/model/universal';


export default /*#__PURE__*/_defineComponent({
  __name: 'IllustrationCard',
  props: {
    files: {},
    file: {},
    viewMode: {},
    actionMode: {},
    total: {},
    current: {},
    illust: {},
    isFilterFavorite: { type: Boolean },
    imageLoading: {}
  },
  emits: ["click"],
  setup(__props: any) {

const isLoading = ref(true);
const isError = ref(false);
const imagePlaceholder = ref(
	'https://www.signfix.com.au/wp-content/uploads/2017/09/placeholder-600x400.png'
);





return (_ctx: any,_cache: any) => {
  const _component_a_badge = _resolveComponent("a-badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ImageCard, {
      target: "_blank",
      viewMode: _ctx.viewMode,
      isLoading: isLoading.value,
      link: `/${_unref(DocumentType).Illustration}/${_ctx.illust.metadata.metadataID}/${_ctx.illust.documentUUID}${_ctx.isFilterFavorite ? '?isFavorite=true' : ''}`,
      clickable: _ctx.actionMode === _unref(ActionMode).View && !isError.value && !isLoading.value
    }, {
      default: _withCtx(() => [
        (!isError.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.file.thumbnailURL,
              alt: "",
              loading: _ctx.imageLoading ?? 'lazy',
              referrerPolicy: "no-referrer",
              class: _normalizeClass(
				(isLoading.value ? 'w-0 h-0 ' : '') +
				'object-cover rounded-md shadow-xl drop-shadow-lg ' +
				(_ctx.viewMode !== _unref(DocumentViewMode).List
					? 'absolute top-0 right-0 z-20 w-full h-full'
					: 'max-w-2xl w-full')
			),
              onLoad: _cache[0] || (_cache[0] = 
				() => {
					(isLoading.value = false), (isError.value = false);
				}
			),
              onError: _cache[1] || (_cache[1] = 
				() => {
					(isLoading.value = false), (isError.value = true);
				}
			),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click', _ctx.illust, _ctx.file)))
            }, null, 42, _hoisted_1))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: imagePlaceholder.value,
              alt: "",
              loading: _ctx.imageLoading ?? 'lazy',
              referrerPolicy: "no-referrer",
              class: _normalizeClass(
				(isLoading.value ? 'w-0 h-0 ' : '') +
				'object-cover rounded-md shadow-xl drop-shadow-lg ' +
				(_ctx.viewMode !== _unref(DocumentViewMode).List
					? 'absolute top-0 right-0 z-20 w-full h-full'
					: 'max-w-2xl w-full')
			)
            }, null, 10, _hoisted_2)),
        (_ctx.file.mimeType.startsWith('video/') && !isLoading.value)
          ? (_openBlock(), _createBlock(_unref(PlayCircleFilled), {
              key: 2,
              class: _normalizeClass(
				'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-30 text-black opacity-75 ' +
				(_ctx.viewMode === _unref(DocumentViewMode).List ? 'text-8xl' : 'text-4xl')
			)
            }, null, 8, ["class"]))
          : _createCommentVNode("", true),
        (!isError.value && !isLoading.value && _ctx.files.length > 1 && _ctx.viewMode === _unref(DocumentViewMode).Stack)
          ? (_openBlock(), _createElementBlock("img", {
              key: 3,
              src: _ctx.files[1].thumbnailURL,
              alt: "",
              loading: _ctx.imageLoading ?? 'lazy',
              referrerPolicy: "no-referrer",
              class: "object-cover w-full h-full rounded-md shadow-xl drop-shadow-lg absolute -top-1 -right-1 z-10 brightness-50"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (!isError.value && !isLoading.value && _ctx.files.length > 1 && _ctx.viewMode === _unref(DocumentViewMode).Stack)
          ? (_openBlock(), _createBlock(_component_a_badge, {
              key: 4,
              count: _ctx.files.length,
              class: "absolute top-1 right-1 z-20"
            }, null, 8, ["count"]))
          : _createCommentVNode("", true),
        (
				!isError.value &&
				!isLoading.value &&
				(_ctx.file.isFavorite ||
					(_ctx.viewMode === _unref(DocumentViewMode).Stack && _ctx.files.findIndex((f) => f.isFavorite) !== -1))
			)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(StarFilled))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["viewMode", "isLoading", "link", "clickable"]),
    (_ctx.viewMode === _unref(DocumentViewMode).List)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.current) + " / " + _toDisplayString(_ctx.total), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})